/* eslint-disable prettier/prettier */
/* eslint-disable */

import { BaseInputLabel, FormControl } from 'portfolio3/ui-kit';
import { Select } from 'portfolio3/ui-kit/selects';
import { IController } from 'portfolio3/ui-kit/types';
import React, { useContext, useEffect, useMemo } from 'react';

import { IDictionaryItem } from '../../../../api/types';
import { LocalDataEntryFormContext } from '../context/localDataEntryFormContext';

interface IOccupationBlockProps {
  typeOptions: IDictionaryItem[];
}

const OccupationBlock: React.FC<IOccupationBlockProps> = ({
  typeOptions,
}) => {
  const { inputRenderMode, inputSize, formData, onChangeFormData } = useContext(LocalDataEntryFormContext);

  const typeController: IController<string | undefined> = useMemo(() => ({
    handleChange: (type) => {
      onChangeFormData((prevstate) => ({
        ...prevstate,
        typeCode: Number(type)
      }));
    }
  }), [formData.id]);

  useEffect(() => {
    if (typeOptions.length === 1) {
      onChangeFormData({
        ...formData,
        typeCode: typeOptions[0].code
      });
    }
  }, [typeOptions.length]);

  const isTypeSelectDisabled = typeOptions.length < 2;
  return (
    <>
      <FormControl
        renderMode={inputRenderMode}
        inputSize={inputSize}
        disabled={isTypeSelectDisabled}
        label={<BaseInputLabel>Тип занятия</BaseInputLabel>}
        control={
          <Select
            inputRenderMode={inputRenderMode}
            inputSize={inputSize}
            placeholder="Выберите тип занятия..."
            value={formData.typeCode}
            options={typeOptions}
            controller={typeController}
            strictMaxWidth
          />
        }
      />
    </>
  );
};

export default OccupationBlock;
